import React from "react";
import { DetailsGrid, DetailRow, DetailLabel, DetailValue, IdBadge } from "./ConnectionDetails";

export const AnalyticsViewDetails = ({ settings }) => {
    if (!settings.tokenName) return null;

    return (
        <DetailsGrid>
            <DetailRow>
                <DetailLabel>Google account</DetailLabel>
                <DetailValue>{settings.analyticsAccountOwner}</DetailValue>
            </DetailRow>
            {settings.accountId && (
                <DetailRow>
                    <DetailLabel>Account</DetailLabel>
                    <DetailValue>
                        <IdBadge>{settings.accountId}</IdBadge>
                        {settings.accountDisplayName}
                    </DetailValue>
                </DetailRow>
            )}
            {settings.propertyId && (
                <DetailRow>
                    <DetailLabel>Property</DetailLabel>
                    <DetailValue>
                        <IdBadge>{settings.propertyId}</IdBadge>
                        {settings.propertyDisplayName}
                    </DetailValue>
                </DetailRow>
            )}
        </DetailsGrid>
    );
};
